<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="name"
    track-by="id"
    :options="options"
    :disabled="!editable"
    :allow-empty="false" />
</template>
<script>
export default {
  name: 'ConsultingRoomInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      options: []
    };
  },
  mounted() {
    this.axios.get('/admin/activeconsultingrooms')
      .then((res) => {
        this.options = res.data.result;
        // eslint-disable-next-line prefer-destructuring
        this.fieldModelValue = this.options[0];
      });
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', this.options[0].id);
        return (
          this.options.find((x) => x.id === this.value)
          || this.options.find((x) => x.id === 0)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.id);
      }
    }
  },
  methods: {
    getDoctor(val) {
      return this.options.find((x) => x.id === val).doctorId;
    }
  }

};
</script>
<style lang="scss" scoped></style>
